import React from 'react';
import ReactDOM from 'react-dom';

import { listenToHeightChanges } from 'wix-height-updater';
import { isEditorX } from '@wix/search-shared-libs';
import {
  ViewerScriptWrapper,
  withStyles,
  withSentryErrorBoundary,
} from '@wix/native-components-infra';

import { WidgetRoot } from './components/WidgetRoot/WidgetRoot';
import { viewerScript } from './platform/viewerScript';
import { buildSentryOptions } from './platform/monitoring/sentry';
import { setWidthRestrictions } from './lib/resize';

import './assets/styles/preview-reset.st.css';

const WrappedWidget = ViewerScriptWrapper(
  withSentryErrorBoundary(
    withStyles(WidgetRoot, {
      cssPath: ['editorWidget.stylable.bundle.css'],
    }),
    buildSentryOptions({
      environment: 'Editor-mode component wrapper',
    }),
  ),
  {
    viewerScript,
    Wix: window.Wix,
    widgetConfig: {
      widgetId: '',
      getAllPublicData: true,
    },
    overrides: {
      platform: {
        baseUrls: {
          staticsBaseUrl: window.__STATICS_BASE_URL__,
        },
      },
    },
  },
);

ReactDOM.render(<WrappedWidget />, document.getElementById('root'), () => {
  listenToHeightChanges(window.Wix, window);
  if (!isEditorX()) {
    setWidthRestrictions(window.Wix);
  }
});
